<template>
  <div class="project-vip-rights-widget-edit relative">
    <menu-item label="背景设置">
      <menu-fill :target="model.background" target-key="background" />
      <menu-background-image :target="model.background" class="mt-2" />
    </menu-item>

    <menu-item label="文字颜色">
      <menu-fill :target="model.textColor" target-key="textColor" solid-color />
    </menu-item>

    <menu-item label="权益背景">
      <menu-fill :target="model.rightsBg" target-key="rightsBg" />
    </menu-item>

    <menu-item label="按钮填充色">
      <menu-fill :target="model.btnBg" target-key="btnBg" />
    </menu-item>

    <menu-item label="按钮文字色">
      <menu-fill :target="model.btnTextColor" target-key="btnTextColor" solid-color />
    </menu-item>
    <menu-item label="标题背景">
      <menu-fill :target="model.titleBg" target-key="titleBg" solid-color />
      <menu-background-image :target="model.titleBg" class="mt-2" />
    </menu-item>
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import MenuItem from "~/components/menu/menuItem.vue";
import MenuFill from "~/components/menu/menuFill.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";

export default {
  name: 'ProjectVipRightsWidgetEdit',
  components: {
    MenuItem,
    MenuFill,
    MenuBackgroundImage
  },
  props: {
    site: Object,
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style lang="less"></style>